module.exports = __webpack_public_path__ + "img/infographicWhatWeDoVertical.d4a5edaa.png";